// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  leaseId: __t.u64().primaryKey().name("lease_id"),
  shipId: __t.u64().name("ship_id"),
  captain: __t.identity(),
  holder: __t.identity(),
  role: __t.string(),
  actions: __t.string(),
  epoch: __t.u32(),
  state: __t.string(),
  endReason: __t.string().name("end_reason"),
  kitBudget: __t.u32().name("kit_budget"),
  kitsUsed: __t.u32().name("kits_used"),
  expiresAt: __t.timestamp().name("expires_at"),
  graceUntil: __t.timestamp().name("grace_until"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
